import { FC, useRef, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FormInstance } from "antd";
import {
  AppButton,
  AuthLayout,
  Form,
  FORM_FIELD_TYPES,
  IFormItems,
} from "site/ui/base";
import { useNotification } from "providers";
import { routeNames } from "utils";

const ButtonContainer = styled.div`
  margin-top: 0.5rem;
`;

const ForgotPasswordLink = styled(Link)`
  display: block;
  text-align: center;
  color: #828080;
  text-decoration: none;
  font-size: 0.875rem;
  margin-top: 1rem;

  &:hover {
    text-decoration: underline;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 2rem 0;
  color: #666;
  font-size: 0.875rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e2e8f0;
  }

  &::before {
    margin-right: 1rem;
  }

  &::after {
    margin-left: 1rem;
  }
`;

const SocialButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SocialButtonWrapper = styled(AppButton)`
  flex: 1;
  background: white !important;
  border: 1px solid #e2e8f0 !important;
  color: #333 !important;
  box-shadow: none !important;
  padding: 12px 24px !important;
  font-family: "Manrope", sans-serif !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: #f8f9fa !important;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

const SignUpText = styled.p`
  text-align: center;
  margin-top: 2rem;
  font-size: 0.875rem;
  color: #666;

  a {
    color: #5575f7;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
interface ILoginIData {
  email: string;
  password: string;
}
export interface LoginProps {
  onLogin: (data: ILoginIData) => Promise<boolean>
}
export const Login:FC<LoginProps> = ({
  onLogin
}) => {
  const formRef = useRef<FormInstance<ILoginIData>>(null);
  const [loading, setLoading] = useState(false)
  const notification = useNotification()

  const formItems: IFormItems[] = [
    {
      fieldType: FORM_FIELD_TYPES.TEXT,
      itemProps: {
        name: "email",
        label: "Email address",
        rules: [{ required: true, message: "Please input your email!" }],
      },
      fieldProps: {
        placeholder: "esosa@example.art",
        size: "large",
      },
    },
    {
      fieldType: FORM_FIELD_TYPES.PASSWORD,
      itemProps: {
        name: "password",
        label: "Password",
        rules: [{ required: true, message: "Please input your password!" }],
      },
      fieldProps: {
        placeholder: "• • • • • • •",
        size: "large",
      },
    },
  ];

  const login = () => {
    const data = formRef.current?.getFieldsValue()
    const email = data?.email?.trim();
    const password = data?.password?.trim();
    if(!email || !password){
      return notification.error({
        message: "invalid credential"
      })
    }
    setLoading(true)
    onLogin({email, password}).finally(() => setLoading(false))
  }

  return (
    <AuthLayout title="Welcome back!">
      <Form
        formRef={formRef}
        items={formItems}
        formProps={{
          layout: "vertical",
        }}
      />

      <ButtonContainer>
        <AppButton loading={loading} variant="primary" fullWidth onClick={login}>
          Login
        </AppButton>
        <ForgotPasswordLink to={routeNames.forgetPass}>
          Forgot your password?
        </ForgotPasswordLink>
      </ButtonContainer>

      {/* <Divider>Or continue with</Divider>

      <SocialButtonsContainer>
        <SocialButtonWrapper onClick={() => console.log("Google login")}>
          <img src="/assets/google.png" alt="Google" />
          Continue with Google
        </SocialButtonWrapper>
        <SocialButtonWrapper onClick={() => console.log("Apple login")}>
          <img src="/assets/apple.png" alt="Apple" />
          Continue with Apple
        </SocialButtonWrapper>
      </SocialButtonsContainer> */}

      <SignUpText>
        No account? No worries. <Link to={routeNames.signUp}>Create one here</Link>
      </SignUpText>
    </AuthLayout>
  );
};
